module.exports = __webpack_public_path__ + "static/media/fb.4d9ef73e.svg";